"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _react = _interopRequireDefault(require("react"));
var _martySkiLeft = _interopRequireDefault(require("../assets/marty-ski-left.png"));
var _cogShooter = _interopRequireDefault(require("../assets/cog-shooter.png"));
var _ConfettiExplosion = _interopRequireDefault(require("../ConfettiExplosion"));
var _fi = require("react-icons/fi");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ShouldIStayOrShouldIGo = _ref => {
  let {
    keepPlaying,
    goNext
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.container,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfettiExplosion.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _stylesModule.default.background,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
        className: _stylesModule.default.emojiTitle,
        children: "\uD83C\uDF89 Well Done! \uD83C\uDF89"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _stylesModule.default.buttons,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _stylesModule.default.buttonWrapper,
          onClick: keepPlaying,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            className: "".concat(_stylesModule.default.button, " ").concat(_stylesModule.default.buttonPlayAgain),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _martySkiLeft.default,
              alt: "Play Again",
              className: "".concat(_stylesModule.default.buttonImage, " ").concat(_stylesModule.default.slalom)
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: _stylesModule.default.label,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fi.FiRepeat, {
              className: _stylesModule.default.icon
            }), "Play Again"]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _stylesModule.default.buttonWrapper,
          onClick: goNext,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            className: "".concat(_stylesModule.default.button, " ").concat(_stylesModule.default.buttonNextLevel),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _cogShooter.default,
              alt: "Next Level",
              className: "".concat(_stylesModule.default.buttonImage, " ").concat(_stylesModule.default.cross)
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: _stylesModule.default.label,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fi.FiArrowRightCircle, {
              className: _stylesModule.default.icon
            }), "Next Level"]
          })]
        })]
      })]
    })]
  });
};
var _default = exports.default = ShouldIStayOrShouldIGo;